import GraphicEqRounded from '@mui/icons-material/GraphicEqRounded';
import MicIcon from '@mui/icons-material/Mic';
import { Box, Button } from '@mui/material';
import { bool, func } from 'prop-types';
import React from 'react';
import SendIcon from 'assets/icons/send.svg';
import { I18n } from 'utils/i18n';
import StopButton from '../VoiceMode/StopButton';

const sendButtonSx = theme => ({
  minWidth: 40,
  width: 40,
  height: 40,
  padding: 0,
  borderRadius: '6px',
  fontWeight: 700,
  marginLeft: theme.spacing(0.5),
});

const SendButton = ({
  useMicWhenEmpty = false,
  onStartVoiceRecording = undefined,
  useVoiceCallWhenEmpty = false,
  onStartVoiceCall = undefined,
  voiceActive = false,
  hasText = false,
  onStopVoiceCall = undefined,
}) => {
  // In a live voice call: empty composer → the GraphicEq has morphed into Stop;
  // once the user types, it becomes a Send button while the call keeps listening.
  if (voiceActive && !hasText) {
    return <StopButton onClick={onStopVoiceCall} grow />;
  }

  if (useVoiceCallWhenEmpty && !voiceActive) {
    return (
      <Button
        sx={sendButtonSx}
        type="button"
        variant="contained"
        onClick={onStartVoiceCall}
        title={I18n.t('VoiceCall.startCall')}
        aria-label={I18n.t('VoiceCall.startCall')}
      >
        <GraphicEqRounded sx={theme => ({ fontSize: 22, color: theme.palette.white })} />
      </Button>
    );
  }

  if (useMicWhenEmpty) {
    return (
      <Button
        sx={sendButtonSx}
        type="button"
        variant="contained"
        onClick={onStartVoiceRecording}
        title={I18n.t('SendMessageForm.Record voice message')}
        aria-label={I18n.t('SendMessageForm.Record voice message')}
      >
        <MicIcon sx={theme => ({ fontSize: 22, color: theme.palette.white })} />
      </Button>
    );
  }

  return (
    <Button
      sx={sendButtonSx}
      type="submit"
      variant="contained"
      title={I18n.t('SendMessageForm.Send')}
      aria-label={I18n.t('SendMessageForm.Send')}
    >
      <Box
        component={SendIcon}
        sx={theme => ({ width: 19, height: 19, color: theme.palette.white })}
      />
    </Button>
  );
};

SendButton.propTypes = {
  useMicWhenEmpty: bool,
  onStartVoiceRecording: func,
  useVoiceCallWhenEmpty: bool,
  onStartVoiceCall: func,
  voiceActive: bool,
  hasText: bool,
  onStopVoiceCall: func,
};

export default SendButton;
